module.exports = __webpack_public_path__ + "static/media/alibaba.95b0034d.jpg";